import { render, staticRenderFns } from "./payShare.vue?vue&type=template&id=f089185a&"
import script from "./payShare.vue?vue&type=script&lang=js&"
export * from "./payShare.vue?vue&type=script&lang=js&"
import style0 from "./payShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports